/* eslint-disable */
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'

import MainTitle from '../../components/MainTitle'
import ClientNav from '../../components/ClientNav'
import useAuth from '../../hooks/useAuth'
import moment from 'moment'

import TCBanner from './TCBanner'

const OHASession = ({
  clientData = {},
  claimData = {},
  sessionData = {},
}) => {
  const navigate = useNavigate()

  const { clientId, claimId, sessionId } = useParams()
  const { auth } = useAuth()

  const [edit, setEdit] = useState(false)
  const [singlTaskId, setSinglTaskId] = useState('')
  const [serviceRequestId, setServiceRequestId] = useState('')
  const [bookingId, setBookingId] = useState('')

  const [additionalData, setAdditionalData] = useState({})

  const [completedById, setCompletedById] = useState(null)
  const [completedByName, setCompletedByName] = useState('')
  const [completedAtDate, setCompletedAtDate] = useState(null)

  useEffect(() => {
    if (!sessionData?.additional_data) return

    let additionalDataOriginal = sessionData.additional_data

    setAdditionalData(additionalDataOriginal)

    if (additionalDataOriginal?.assessmentStatus === 'pending') {
      setEdit(true)
    }

    setSinglTaskId(additionalDataOriginal?.singlTaskId || '')
    setServiceRequestId(additionalDataOriginal?.serviceRequestId || '')
    setBookingId(additionalDataOriginal?.bookingId || '')
    setCompletedById(additionalDataOriginal?.userId || null)
    setCompletedByName(additionalDataOriginal?.userName || '')
    setCompletedAtDate(additionalDataOriginal?.assessmentCompletedAt || null)
  }, [sessionData])

  const goToClaim = () => {
    navigate(`/clients/${clientId}/claims/${claimId}`)
  }

  return (
    <div>
      <MainTitle
        title={`Client: ${clientData.name} (${clientData.reference})`}
        client={clientData}
        claim={claimData}
        backButton
        child={clientData.child}
      />

      {clientData.id &&
        <ClientNav
          active="claims"
          client={clientData}
          audit={sessionData.id}
          type={'Session'}
          id={clientId}
        />
      }

      {clientData.id && <TCBanner clientData={clientData} />}

      {sessionData.id && (
        <section>
          <span
            className="inline-flex items-center text-slate-500 mb-2 cursor-pointer hover:text-slate-600"
            onClick={goToClaim}
          >
            <FontAwesomeIcon icon={faChevronLeft} className="text-sm" />
            <span className="text-sm ml-2">View Claim</span>
          </span>

          {additionalData?.assessmentStatus === 'completed' ? (
            <>
              <section className="bg-white rounded-xl shadow-md py-8 px-8 max-w-4xl mx-auto">
                <h2 className="font-bold text-2xl mb-6 text-center text-gray-800">Assessment Completed</h2>
                <p className="text-gray-600 text-center mb-4">This assessment was completed by <strong>{completedByName}</strong> and completed on <strong>{completedAtDate && moment(completedAtDate).format('DD/MM/YYYY HH:mm')}</strong>.</p>
              </section>
            </>
          ) : (
            <section className="bg-white rounded-xl shadow-md py-8 px-8 max-w-4xl mx-auto">
              <h2 className="font-bold text-2xl mb-6 text-center text-gray-800">Assessment Process</h2>

              <div className="mb-8">
                <h3 className="font-semibold text-lg mb-4 text-gray-700">What to do:</h3>
                <ol className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">1</span>
                    <span>When you are ready to perform the assessment, click the <strong>"Perform Assessment"</strong> button below.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">2</span>
                    <span>Complete the assessment form with all required information.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">3</span>
                    <span>You can <strong>save your progress as a draft</strong> at any point and return to it later.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5">4</span>
                    <span>Once complete, <strong>submit the assessment</strong> to finish the process.</span>
                  </li>
                </ol>
              </div>

              <div className="flex justify-center space-x-4">
                {sessionData?.status !== "Completed" ? (
                  // If session not been completed, pass session id so can be completed once submitted
                  <a
                    href={`${process.env.REACT_APP_SINGL_BASE_URL}/wba/oh-pdf-form/${singlTaskId}/${serviceRequestId}/${bookingId}/${edit}?token=${localStorage.getItem('token')}&userId=${auth?.user?.id}&sessionId=${sessionId}`}
                    className={`btn ${!singlTaskId || !serviceRequestId || !bookingId ? 'disabled border-none' : 'primary'} px-8 py-3 text-lg font-medium`}
                    disabled={!singlTaskId || !serviceRequestId || !bookingId}
                    target="_blank"
                  >
                    {additionalData?.assessmentStatus === 'ongoing' ? 'Amend Assessment' : 'Perform Assessment'}
                  </a>
                ) : (
                  <a
                    href={`${process.env.REACT_APP_SINGL_BASE_URL}/wba/oh-pdf-form/${singlTaskId}/${serviceRequestId}/${bookingId}/${edit}?token=${localStorage.getItem('token')}&userId=${auth?.user?.id}`}
                    className={`btn ${!singlTaskId || !serviceRequestId || !bookingId ? 'disabled border-none' : 'primary'} px-8 py-3 text-lg font-medium`}
                    disabled={!singlTaskId || !serviceRequestId || !bookingId}
                    target="_blank"
                  >
                    {additionalData?.assessmentStatus === 'ongoing' ? 'Amend Assessment' : 'Perform Assessment'}
                  </a>
                )}
                {/* <button
                onClick={goToClaim}
                className="btn red px-8 py-3 text-lg font-medium"
              >
                Cancel
              </button> */}
              </div>
            </section>
          )}
        </section>
      )}
    </div>
  )
}

export default OHASession
